import { useMutation } from '@apollo/client'
import { studentRegistrationMutation } from '../../../appsync/graphql/student'
import { updateStudentRegistration } from '../../../appsync/actions/student'
import { updateStudentIsRegistered } from '../../../appsync/actions/settings'
import { formatAppsyncErrors } from '../../../appsync/utils'

const useStudentUpdateRegistrationMutation = ({ educationPeriod, refresh }) => {
  const [mutate, { data: rawData = {}, called, loading, error: rawError = null, client }] =
    useMutation(studentRegistrationMutation, {
      onCompleted: () => updateStudentIsRegistered(client),
      update(cache, { data: { saveStudentRegistration } }) {
        updateStudentRegistration({
          cache,
          educationPeriod,
          data: { ...saveStudentRegistration },
          refresh,
        })
      },
    })
  const data = rawData?.saveStudentRegistration ?? {}
  const error = rawError ? formatAppsyncErrors(rawError) : null

  return { mutate, data, called, loading, error }
}

export default useStudentUpdateRegistrationMutation
